<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-modal
      id="reportModal"
      ref="reportModal"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="xl"
      centered
    >
      <template v-slot:modal-header class="border-0">
        <h4>جزئیات گزارش</h4>
      </template>
      <div v-if="busy" class="text-center">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <div>
          <h5 class="text-primary">گزارش پژوهشگر</h5>
          <b-table
            responsive
            small
            show-empty
            head-variant="light"
            :items="reportDetails"
            :fields="researcherFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(percent)="data">
              <div style="text-align: center; vertical-align: middle">
                <span>{{
                  data.value == "-" || data.value == "" ? "-" : "%" + data.value
                }}</span>
              </div>
            </template>
            <template v-slot:cell(description)="data">
              <div style="text-align: center; vertical-align: middle">
                <span>{{ data.value ? data.value : "-" }}</span>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
              <div style="text-align: center; vertical-align: middle">
                <a
                  v-if="data.item.file"
                  class="btn btn-success m-1"
                  :href="data.item.file"
                  target="_blank"
                  >دریافت گزارش</a
                >
                <a
                  v-if="data.item.financeFile"
                  class="ml-2 btn btn-success m-1"
                  :href="data.item.financeFile"
                  target="_blank"
                  >دریافت درخواست مالی</a
                >
                <span v-if="!data.item.financeFile && !data.item.file">-</span>
              </div>
            </template>
          </b-table>

          <br />
          <hr />
          <h5 class="text-primary">گزارش ناظر</h5>
          <b-table
            responsive
            small
            show-empty
            head-variant="light"
            :items="reportDetails"
            :fields="refereeFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(judge)="data">
              <div style="text-align: center; vertical-align: middle">
                <span>{{ data.value ? data.value : "-" }}</span>
              </div>
            </template>
            <template v-slot:cell(judgePer)="data">
              <div style="text-align: center; vertical-align: middle">
                <span>{{
                  data.value == "-" || data.value == "" ? "-" : "%" + data.value
                }}</span>
              </div>
            </template>
            <template v-slot:cell(refereeId)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value == "" || data.value == " " ? "-" : data.value }}
              </div>
            </template>
            <template v-slot:cell(judgeDescription)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
          </b-table>
          <br />
          <hr />
          <h5 class="text-primary">گزارش مدیر</h5>
          <b-table
            responsive
            small
            show-empty
            head-variant="light"
            :items="reportDetails"
            :fields="adminFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(adminMessage)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(adminPer)="data">
              <div style="text-align: center; vertical-align: middle">
                <span>{{
                  data.value == "-" || data.value == "" ? "-" : "%" + data.value
                }}</span>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
          </b-table>
          <br />
          <b-row>
            <b-col>
              <b-form-group
                label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :"
              >
                <b-form-input
                  type="number"
                  :no-wheel="true"
                  min="0"
                  max="100"
                  class="myselect2"
                  @change="dynamicOver100()"
                  v-model="reportDetails2.adminPer"
                >
                </b-form-input>
              </b-form-group> </b-col
            ><b-col>
              <b-form-group label="توضیحات:">
                <b-form-textarea
                  class="myselect2"
                  v-model="reportDetails2.adminMessage"
                >
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-row class="w-100">
          <b-col>
            <b-button
              class="w-100 d-block"
              @click="submitReport('needsCorrection')"
              variant="warning"
              :disabled="
                busy || !reportDetails2.adminPer || !reportDetails2.adminMessage
              "
              >نیاز به اصلاح</b-button
            >
          </b-col>
          <b-col>
            <b-button
              class="w-100 d-block"
              @click="submitReport('approved')"
              variant="success"
              :disabled="
                busy || !reportDetails2.adminPer || !reportDetails2.adminMessage
              "
              >تایید</b-button
            >
          </b-col>
          <b-col>
            <b-button
              class="w-100 d-block"
              @click="submitReport('declined')"
              variant="danger"
              :disabled="
                busy || !reportDetails2.adminPer || !reportDetails2.adminMessage
              "
              >رد</b-button
            >
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-card
      v-if="$router.currentRoute.path == '/admin/todo/newReports'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <p>
        ادمین گرامی؛
        <br />
        گزارش‌های کنترل پروژه ثبت شده توسط پژوهشگر در این بخش نمایش داده میشود.
        <br />
        شما میتوانید روی نام هر حمایت کلیک کنید و وارد بخش کنترل پروژه آن شوید.
        همچنین میتوانید با کلیک روی گزینه‌ی نمایش گزارش، گزارش بارگذاری شده را
        مشاهده کنید و آن را تایید شده، رد شده، یا نیاز به اصلاح تشخیص دهید.
      </p>
      <h6>
        <hr />
        <b-button
          @click="
            selectedType = 'all';
            currentPage = 1;
          "
          :variant="selectedType == 'all' ? 'primary' : 'outline-primary'"
          class="m-1"
          >همه ({{ items.length }})</b-button
        >
        <b-button
          v-for="type in types"
          :key="type.key"
          @click="
            selectedType = type.key;
            currentPage = 1;
          "
          :disabled="!items.filter((x) => x.requestType == type.key).length"
          :variant="selectedType == type.key ? 'primary' : 'outline-primary'"
          class="m-1"
          >{{ type.title }} ({{
            items.filter((x) => x.requestType == type.key).length
          }})</b-button
        >
        <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 25px 1px">
          <v-col>
            <h4 style="margin-top: 9px">
              {{ selectedType == "all" ? "همه درخواست‌ها" : selectedType }}
            </h4>
          </v-col>
          <v-col>
            <v-btn
              class="bc-primary text-white btn-radius float-end"
              width="200"
              height="45"
              elevation="0"
              :disabled="isBusy || !computedItems.length"
              @click="$refs.table1.$el.click()"
            >
              <span class="fs-small">
                خروجی اکسل

                <v-icon>$Excel</v-icon></span
              >
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="table1"
              :data="computedItems"
              :columns="excelFields"
              :filename="
                'لیست گزارش های جدید کنترل پروژه (' +
                (selectedType == 'all' ? 'همه درخواست‌ ها' : selectedType) +
                ')'
              "
              :sheetname="currentDate"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            class="mt-1"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(time)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.item.last_update }}
          </div>
        </template>
        <template v-slot:cell(faSubject)="data">
          <div style="text-align: center; vertical-align: middle">
            <a
              :href="'/admin/' + data.item.requestTypeEn + '/' + data.item.pcId"
              target="_blank"
              >{{ data.value }}</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <b-button
              class="text-light"
              variant="primary"
              @click="openReport(data.item)"
              >نمایش گزارش</b-button
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="selectedType == 'all' ? totalRows : computedItems.length"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "faSubject", label: "عنوان حمایت" },
        { key: "reportSubject", label: "عنوان گزارش" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "requestType", label: "نوع حمایت" },
        { key: "project_code", label: "کد طرح" },
        { key: "time", label: "آخرین بروزرسانی", sortable: true },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "faSubject", label: "عنوان حمایت" },
        { field: "reportSubject", label: "عنوان گزارش" },
        { field: "researcherName", label: "نام پژوهشگر" },
        { field: "requestType", label: "نوع حمایت" },
        { field: "project_code", label: "کد طرح" },
        { field: "time", label: "آخرین بروزرسانی", sortable: true },
      ],
      types: [
        { key: "طرح پژوهشی", title: "طرح" },
        { key: "رساله دکتری", title: "رساله دکتری" },
        { key: "پایان نامه کارشناسی ارشد", title: "پایان‌نامه ارشد" },
        { key: "فرصت مطالعاتی", title: "فرصت مطالعاتی" },
        { key: "نشست تخصصی", title: "نشست تخصصی" },
        { key: "پسادکتری", title: "پسادکتری" },
        { key: "نخبگان وظیفه", title: "نخبگان وظیفه" },
      ],
      researcherFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "percent", label: "درصد پیشرفت" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "فایل" },
      ],
      adminFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "adminPer", label: "درصد پیشرفت" },
        { key: "adminMessage", label: "توضیحات" },
      ],
      refereeFields: [
        { key: "index", label: "ردیف" },
        { key: "refereeId", label: "ناظر" },
        { key: "judge", label: "وضعیت" },
        { key: "judgePer", label: "درصد پیشرفت" },
        { key: "judgeDescription", label: "توضیحات" },
      ],
      items: [],
      filter: "",
      selectedType: "all",
      isBusy: true,
      busy: false,
      selectedReport: {},
      reportDetails: [],
      reportDetails2: [],
      adminPercentage: 0,
      description: "",
    };
  },

  methods: {
    openReport(item) {
      this.reportDetails = [];
      this.selectedReport = item;
      this.adminPercentage = 0;
      this.description = "";
      this.busy = true;
      this.showModal("reportModal");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/report/getInfo",
          {
            reportId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.reportDetails.push(res.data);
          this.reportDetails2 = JSON.parse(JSON.stringify(res.data));
          this.busy = false;
        })
        .catch((err) => {
          this.busy = false;
          this.hideModal("reportModal");
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    submitReport(status) {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/report/" + status,
          {
            reportId: this.selectedReport.id,
            adminPer: this.reportDetails2.adminPer,
            adminMessage: this.reportDetails2.adminMessage,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.hideModal("reportModal");
          this.toast(res.data, "success");
          this.onMounted();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    dynamicOver100() {
      if (this.adminPercentage > 100 || this.adminPercentage < 0) {
        this.adminPercentage = "";
      }
    },
    hideModal(id) {
      // NOTE (m-hideModal) to hide modal
      this.$refs[id].hide();
    },
    showModal(id) {
      // NOTE (m-showModal) to show modal
      this.$refs[id].show();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      this.isBusy = true;
      // NOTE (MOUNTED) to show the proposals data

      this.$http
        .post(
          this.baseUrl + "/setad/admin/pcs/newreports",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  computed: {
    computedItems() {
      let filtered = [];
      if (this.selectedType != "all") {
        filtered = this.items.filter((x) => x.requestType == this.selectedType);
      } else {
        filtered = this.items;
      }
      return filtered;
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/todo/newReports")
      this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
